import { render } from "./WebIcon.vue?vue&type=template&id=73f97dc0&bindings={}"
import script from "./WebIcon.vue?vue&type=script&lang=js"
export * from "./WebIcon.vue?vue&type=script&lang=js"
script.render = render

export default script